import { useField, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

const FormSelect = ({ name, label, options, placeholder, allowEmpty = false }) => {
  const { t } = useTranslation()
  const [field, meta, helpers] = useField(name)
  const { submitCount } = useFormikContext()
  const showError = Boolean(meta.error && (meta.touched || submitCount > 0))

  return (
    <div className="mb-4 last:mb-0">
      {label ? (
        <label className="mb-2 block text-left text-sm font-medium text-gray-700" htmlFor={field.name}>
          {label}
        </label>
      ) : null}
      <select
        id={field.name}
        name={field.name}
        value={field.value ?? ''}
        onChange={(e) => {
          const value = e.target.value
          helpers.setValue(value === '' ? null : Number(value))
        }}
        onBlur={field.onBlur}
        className={`w-full rounded-md border px-3 py-2 text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-[#006EAB] focus:border-[#006EAB] ${
          showError ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-gray-100'
        }`}
      >
        <option value="">{allowEmpty ? t('helpdesk.form.select_empty') : placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {showError ? <span className="mt-1 block text-xs text-red-500">{meta.error}</span> : null}
    </div>
  )
}

export default FormSelect
